import { useEffect, useState } from "react";
import { initiateSocketConnection } from "../socket/socket";

/**
 * Purpose
 *
 * Initializes a socket connection
 *
 * Returns:
 * - `socket`: active socket instance
 * - `connected`: connection status (boolean)
 */

const useSocketConnection = (plantCode, accessToken) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (plantCode && accessToken) {
      try {
        const socketInstance = initiateSocketConnection(plantCode, accessToken);
        setSocket(socketInstance);

        socketInstance.on("connect", () => setConnected(true));

        socketInstance.on("connect_error", (err) => {
          console.error("Socket connection error:", err);
          setConnected(false);
        });

        socketInstance.on("reconnect", () => {
          console.info("Reconnected to socket server");
          setConnected(true);
        });

        socketInstance.on("disconnect", (err) => {
          console.error("Socket disconnected:", err);
          setConnected(false);
        });

        return () => {
          socketInstance.disconnect();
          socketInstance.off("connect");
          socketInstance.off("connect_error");
          socketInstance.off("reconnect");
          socketInstance.off("disconnect");
          setConnected(false);
        };
      } catch (err) {
        console.error(err);
      }
    }
  }, [plantCode, accessToken]);

  return { socket, connected };
};

export default useSocketConnection;
